import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {AuthService} from '@labshare/ngx-core-services';
import {AsrRoutePath} from '../../../ngx-asr-lib/src/lib/constants';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  public onAuthorizationResult;
  public isLoggingEnable = false;
  constructor(private authService: AuthService, private router: Router) {
    this.onAuthorizationResult = this.authService.onAuthorizationResult();
  }

  ngOnInit(): void {
    this.authService.onAuthCallback();
    this.onAuthorizationResult.subscribe(result => {
      if (result.authorizationState === 'authorized') {
        this.router.navigate([[AsrRoutePath.ASR_URL, AsrRoutePath.HOME_URL].join('/')]);
      }
    });
  }
}
